import apiClient from './apiClient';
import type {
  CreateProjectRequest,
  PaginatedResponse,
  Project,
} from '../types/project';

export interface GetProjectsParams {
  page?: number;
  pageSize?: number;
  status?: string;
  clientKey?: string;
  search?: string;
  startDate?: string;
  endDate?: string;
  sortBy?: string;
  sortDir?: 'asc' | 'desc';
}

export const getProjects = async (
  params: GetProjectsParams = {},
): Promise<PaginatedResponse<Project>> => {
  const response = await apiClient.get<PaginatedResponse<Project>>(
    '/projects',
    { params },
  );
  return response.data;
};

export const getStatusCounts = async (): Promise<Record<string, number>> => {
  const response = await apiClient.get<Record<string, number>>('/projects/status-counts');
  return response.data;
};

export const getProjectById = async (id: string): Promise<Project> => {
  const response = await apiClient.get<Project>(`/projects/${id}`);
  return response.data;
};

export const getProjectByProjectId = async (projectId: string): Promise<Project> => {
  const response = await apiClient.get<Project>(`/projects/by-project-id/${projectId}`);
  return response.data;
};

export const getNextProjectId = async (): Promise<string> => {
  const response = await apiClient.get<{ nextId: string }>('/projects/next-id');
  return response.data.nextId;
};

export const createProject = async (data: CreateProjectRequest): Promise<Project> => {
  const response = await apiClient.post<Project>('/projects', data);
  return response.data;
};

export const updateProject = async (
  id: string,
  data: Partial<CreateProjectRequest>,
): Promise<Project> => {
  const response = await apiClient.put<Project>(`/projects/${id}`, data);
  return response.data;
};

export const deleteProject = async (id: string): Promise<void> => {
  await apiClient.delete(`/projects/${id}`);
};
